export enum NotificationScope {
  PERSONAL = "personal",
  ORGANIZATION = "organization",
}
